import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ad55d5d")

_pushScopeId("data-v-7ad55d5d")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "top-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1)
          ]),
          _createVNode(_component_HotspotContentList, {
            list: _ctx.modules.list,
            onAudiobgstop: _ctx.audiobgstop
          }, null, 8, ["list", "onAudiobgstop"])
        ])
      ]))
    : _createCommentVNode("", true)
})